import { OceanFormLocaleProvider } from "@ocean/hook-form"
import { ConfirmProvider } from "@ocean/ui-kit/Confirm"
import { useOceanUiKit } from "@ocean/ui-kit/hooks"
import { SnackbarProvider } from "@ocean/ui-kit/Snackbar"
import { WindowProvider } from "@ocean/ui-kit/Window"

import { AppRouter } from "@/routes/AppRouter"

export function App() {
  useOceanUiKit()

  return (
    <OceanFormLocaleProvider locale="fa-IR">
      <SnackbarProvider>
        <ConfirmProvider>
          <WindowProvider>
            <AppRouter />
          </WindowProvider>
        </ConfirmProvider>
      </SnackbarProvider>
    </OceanFormLocaleProvider>
  )
}
